import { call, put, takeLatest } from "redux-saga/effects";
import {
  addAttenderFailure,
  addAttenderSuccess,
  deleteAttenderFailure,
  deleteAttenderSuccess,
  fetchAttenderFailure,
  fetchAttenderMemberFailure,
  fetchAttenderMemberSuccess,
  fetchAttenderSuccess,
  fetchHistoryAttenderFailure,
  fetchHistoryAttenderSuccess,
  updateAttenderFailure,
  updateAttenderSuccess
} from "./attenderAction";
import {
  addAttenderEffect,
  deleteAttenderEffect,
  editAttenderEffect,
  historyAttenderEffect,
  listAttenderEffect,
  ViewAttenderEffect,
} from "./attenderEffect";
import {
  ADD_ATTENDER_REQUEST,
  DELETE_ATTENDER_REQUEST,
  FETCH_ATTENDER_REQUEST,
  FETCH_LIST_ATTENDER_REQUEST,
  HISTORY_ATTENDER_REQUEST,
  UPDATE_ATTENDER_REQUEST
} from "./attenderType";

function* fetchAttendersSaga(action) {
  try {
    const response = yield call(listAttenderEffect, action.payload);
    yield put(fetchAttenderSuccess(response.data));
  } catch (error) {
    yield put(fetchAttenderFailure(error.message));
  }
}
function* fetchGHistoryAttendersSaga(action) {
  try {
    const response = yield call(historyAttenderEffect, action.payload);
    yield put(fetchHistoryAttenderSuccess(response.data));
  } catch (error) {
    yield put(fetchHistoryAttenderFailure(error.message));
  }
}
function* fetchAttenderSaga(action) {
  try {
    const response = yield call(ViewAttenderEffect, action.payload.staffId,action.payload.patientId);
    yield put(fetchAttenderMemberSuccess(response.data));
  } catch (error) {
    yield put(fetchAttenderMemberFailure(error.message));
  }
}

function* addAttenderSaga(action) {
  try {
      const response = yield call(addAttenderEffect, action.payload);
      yield put(addAttenderSuccess(response.data));
  } catch (error) {

      const backendMessage = error.response?.data?.message || error.message || "Failed to add attender";
      yield put(addAttenderFailure(backendMessage));
  }
}
function* updateAttenderSaga(action) {
  try {
    const response = yield call(
      editAttenderEffect,
      action.payload.attenderId,
      action.payload.attenderData
    );
    yield put(updateAttenderSuccess(response.data));

    if (action.payload.callback) {
      action.payload.callback(true, null); // success
    }
  } catch (error) {
    const backendMessage = error.response?.data?.message || error.message || "Failed to update attender";
    yield put(updateAttenderFailure(backendMessage));

    if (action.payload.callback) {
      action.payload.callback(false, backendMessage); // failure
    }
  }
}


function* deleteAttenderSaga(action) {
  try {
    yield call(deleteAttenderEffect, action.payload.attenderId);
    yield put(deleteAttenderSuccess(action.payload.attenderId));
  } catch (error) {
    yield put(deleteAttenderFailure(error.message));
  }
}

export function* AttenderSagas() {

  yield takeLatest(FETCH_LIST_ATTENDER_REQUEST, fetchAttendersSaga);
  yield takeLatest(FETCH_ATTENDER_REQUEST, fetchAttenderSaga);
  yield takeLatest(ADD_ATTENDER_REQUEST, addAttenderSaga);
  yield takeLatest(UPDATE_ATTENDER_REQUEST, updateAttenderSaga);
  yield takeLatest(DELETE_ATTENDER_REQUEST, deleteAttenderSaga);
  yield takeLatest(HISTORY_ATTENDER_REQUEST, fetchGHistoryAttendersSaga);
}